module.exports = __webpack_public_path__ + "img/南京大学.dbb88d81.png";